import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { style: {"mix-blend-mode":"multiply"} }, [
      _createElementVNode("path", {
        d: "M16.6875 2.75C14.7516 2.75 13.0566 3.5825 12 4.98969C10.9434 3.5825 9.24844 2.75 7.3125 2.75C5.77146 2.75174 4.29404 3.36468 3.20436 4.45436C2.11468 5.54404 1.50174 7.02146 1.5 8.5625C1.5 15.125 11.2303 20.4369 11.6447 20.6562C11.7539 20.715 11.876 20.7458 12 20.7458C12.124 20.7458 12.2461 20.715 12.3553 20.6562C12.7697 20.4369 22.5 15.125 22.5 8.5625C22.4983 7.02146 21.8853 5.54404 20.7956 4.45436C19.706 3.36468 18.2285 2.75174 16.6875 2.75Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }